import types from './types';

const INITIAL_STATE = {
  isEnquiringDiags: false,
  isEnquiringCpts: false,
  isSearchingMembers: false,
  isFetchingCM: false,
  isFetchingMember: false,
  isFetchingOwner: false,
  isFetchingProvider: false,
  isRequestingMember: false,
  isEmailing: false,
  isFetchingCodes: false,

  result: [],
};

const eligibilityReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.ENQUIRE_BULK_DIAGS_REQUEST:
      return {
        ...state,
        result: [],
        isEnquiringDiags: true,
      };

    case types.ENQUIRE_BULK_DIAGS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isEnquiringDiags: false,
      };

    case types.ENQUIRE_BULK_DIAGS_FAILURE:
      return {
        ...state,
        result: [],
        isEnquiringDiags: false,
      };

    case types.ENQUIRE_BULK_CPTS_REQUEST:
      return {
        ...state,
        result: [],
        isEnquiringCpts: true,
      };

    case types.ENQUIRE_BULK_CPTS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isEnquiringCpts: false,
      };

    case types.ENQUIRE_BULK_CPTS_FAILURE:
      return {
        ...state,
        result: [],
        isEnquiringCpts: false,
      };

    case types.SEARCH_MEMBERS_REQUEST:
      return {
        ...state,
        result: [],
        isSearchingMembers: true,
      };

    case types.SEARCH_MEMBERS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isSearchingMembers: false,
      };

    case types.SEARCH_MEMBERS_FAILURE:
      return {
        ...state,
        result: [],
        isSearchingMembers: false,
      };

    case types.GET_CM_WORK_LIST_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingCM: true,
      };

    case types.GET_CM_WORK_LIST_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingCM: false,
      };

    case types.GET_CM_WORK_LIST_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingCM: false,
      };

    case types.GET_MEMBER_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingMember: true,
      };

    case types.GET_MEMBER_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingMember: false,
      };

    case types.GET_MEMBER_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingMember: false,
      };

    case types.GET_MEMBER_REQUEST_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingMember: true,
      };

    case types.GET_MEMBER_REQUEST_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingMember: false,
      };

    case types.GET_MEMBER_REQUEST_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingMember: false,
      };

    case types.GET_TASK_OWNERS_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingOwner: true,
      };

    case types.GET_TASK_OWNERS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingOwner: false,
      };

    case types.GET_TASK_OWNERS_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingOwner: false,
      };

    case types.GET_PROVIDER_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingProvider: true,
      };

    case types.GET_PROVIDER_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingProvider: false,
      };

    case types.GET_PROVIDER_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingProvider: false,
      };

    case types.REQUEST_MEMBER_REQUEST:
      return {
        ...state,
        result: [],
        isRequestingMember: true,
      };

    case types.REQUEST_MEMBER_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isRequestingMember: false,
      };

    case types.REQUEST_MEMBER_FAILURE:
      return {
        ...state,
        result: [],
        isRequestingMember: false,
      };

    case types.EMAIL_UPDATED_MEMBER_INFO_REQUEST:
      return {
        ...state,
        result: [],
        isEmailing: true,
      };

    case types.EMAIL_UPDATED_MEMBER_INFO_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isEmailing: false,
      };

    case types.EMAIL_UPDATED_MEMBER_INFO_FAILURE:
      return {
        ...state,
        result: [],
        isEmailing: false,
      };

    case types.GET_MEMBER_CONDITION_CODES_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingCodes: true,
      };

    case types.GET_MEMBER_CONDITION_CODES_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingCodes: false,
      };

    case types.GET_MEMBER_CONDITION_CODES_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingCodes: false,
      };

    default:
      return state;
  }
};

export default eligibilityReducer;
